import { Calendar, X } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { DatePicker } from '@components/date-picker';
import { Button } from '@components/ui/button';
import { formatDateForApi, parseDateString } from './helpers';

interface VisibilityToggleProps {
    validFrom?: string;
    validTo?: string;
    onValidFromChange: (value: string | undefined) => void;
    onValidToChange: (value: string | undefined) => void;
}

export const VisibilityToggle: React.FC<VisibilityToggleProps> = ({
    validFrom,
    validTo,
    onValidFromChange,
    onValidToChange
}) => {
    const [isVisible, setIsVisible] = useState<boolean>(false);

    useEffect(() => {
        setIsVisible(!!(validFrom || validTo));
    }, []);

    const handleToggle = () => {
        if (isVisible) {
            onValidFromChange(undefined);
            onValidToChange(undefined);
        }
        setIsVisible(!isVisible);
    };

    if (isVisible) {
        return (
            <>
                <DatePicker
                    label="Visible From"
                    className="w-[170px]"
                    value={parseDateString(validFrom)}
                    onChange={(value) =>
                        onValidFromChange(formatDateForApi(value))
                    }
                    clearable
                />
                <DatePicker
                    label="Visible To"
                    className="w-[170px]"
                    value={parseDateString(validTo)}
                    minDate={parseDateString(validFrom) || undefined}
                    onChange={(value) =>
                        onValidToChange(formatDateForApi(value))
                    }
                    clearable
                />
                <Button
                    variant="outline"
                    size="xs"
                    className="rounded-full"
                    onClick={handleToggle}
                >
                    Make always visible
                    <X />
                </Button>
            </>
        );
    }

    return (
        <Button
            variant="outline"
            size="xs"
            className="rounded-full"
            onClick={handleToggle}
        >
            <Calendar />
            Limit visibility
        </Button>
    );
};
